<template>
  <div>
    <!--Header-->
    <div class="header bg-photo pt-5">
      <div class="container">
        <div class="header-body">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="mt-6">
                <i class="fas fa-chart-line"></i>
                <h1 class="display-1 text-white font-weight-bold mb-0">Seu Perfil Empreendedor</h1>
<!--                <h2 class="display-4 text-white font-weight-light">A beautiful premium dashboard for Bootstrap 4.</h2>-->
                <p class="lead text-white mt-4">Descubra se você tem o perfil empreendedor com uma ferramenta super prática e rápida</p>
                <div class="btn-header mt-2 pt-2">
                  <base-button class="my-2" type="secondary">
                    <router-link to="/intro" >Fazer o Teste</router-link>
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>

    </div>
    <!-- Page content -->


    <section class="py-6">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-6 text-center">
            <card>
              <!-- Card body -->
              <a href="#!">
                <img src="img/theme/db.jpg"
                     class="rounded-circle img-center img-fluid shadow shadow-lg--hover" style="width: 140px;">
              </a>
              <div class="pt-4 text-center">
                <h5 class="h3 title">
                  <span class="d-block mb-1">Davi Braga</span>
                  <small class="h4 font-weight-light text-muted">Empreendedor</small>
                </h5>
                <div class="mt-3">
                  <a target="_blank" href="https://instagram.com/davibraga" class="btn btn-dribbble btn-icon-only rounded-circle">
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a target="_blank" href="https://youtube.com/davibraga" class="btn btn-youtube btn-icon-only rounded-circle">
                    <i class="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </card>
            <card class="info-card bg-gradient-secondary">
              <!-- Card body -->
              <div class="row">
                <div class="col-auto">
                  <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                    <i class="fas fa-star"></i>
                  </div>
                </div>
                <div class="col">
                  <h4 class="card-title text-uppercase text-muted mb-0 text-white">Eleito pela Forbes como um dos jovens mais promissores do país</h4>
                </div>
              </div>
            </card>

            <card class="info-card bg-gradient-warning">
              <!-- Card body -->
              <div class="row">
                <div class="col-auto">
                  <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                    <i class="fas fa-pencil-alt"></i>
                  </div>
                </div>
                <div class="col">
                  <h4 class="card-title text-uppercase text-muted mb-0 text-white">Empreendedor<br />Serial</h4>
                </div>
              </div>
            </card>

            <card class="info-card bg-gradient-primary">
              <!-- Card body -->
              <div class="row">
                <div class="col-auto">
                  <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                    <i class="fas fa-bullhorn"></i>
                  </div>
                </div>
                <div class="col">
                  <h4 class="card-title text-uppercase text-muted mb-0 text-white">Mais de 60 palestras<br />pelo Brasil</h4>
                </div>
              </div>
            </card>

            <card class="info-card bg-gradient-danger">
              <!-- Card body -->
              <div class="row">
                <div class="col-auto">
                  <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                    <i class="fas fa-glasses"></i>
                  </div>
                </div>
                <div class="col">
                  <h4 class="card-title text-uppercase text-muted mb-0 text-white">Fundou a Startup LIST-IT<br />aos 13 anos</h4>
                </div>
              </div>
            </card>

            <h2 class="display-3">Empreendedorismo<span class="text-secondary">O que é realmente?</span></h2>
            <p class="lead">Os termos empreendedorismo e startup se popularizaram no Brasil
              nos últimos anos. Mas muita gente ainda acha que basta ter um cnpj
              e uma boa ideia, que vai ficar rico rápido – e, o melhor, livre de
              chefes mal-humorados ou cobranças. ilusão total.
              <br />
              <br />
              O fato de optar por ter uma vida empreendedora não faz ninguém
              trabalhar menos. Pelo contrário. Quando você cumpre ordens e é
              um empregado, tem hora para entrar e sair, almoçar, férias
              programadas. O chefe dos empreendedores é o mercado. E a
              responsabilidade sobre sua vida e a dos que o cercam fica maior.
              Aliás, esses não se “desligam” do seu negócio quase nunca, pelo
              simples fato de precisarem fazer acontecer!
              <br />
              <br />
              Eu tive vários projetos porque sou persistente. Desafio é para ser
              enfrentado, não pare neles. Nunca desista de algo que se propôs a
              fazer. No entanto, permita-se mudar de ideia. Eu já mudei de ideia
              mais de uma vez. Pivotar, ou mudar de direção, é comum e
              necessário, às vezes. Como sou muito determinado, só paro quando
              realmente não deu certo, ou porque algo me obrigou. E não fico
              chorando pelo leite derramado, não. Quando sou obrigado a pivotar,
              eu sigo em frente com mais vontade ainda.
              <br />
              <br />
              O tempo destinado a cada objetivo depende da prioridade
              naquele momento e do tamanho do desafio. Quando se tem muitos
              projetos e coisas pra fazer, estipular um tempo rígido para cada um
              é complicado. Até porque empreender tem um lado imprevisível :
              por mais que planeje tudinho, existem variáveis que não dependem
              de você.
              <br />
              <br />
              Então, vá fazendo conforme a necessidade do contexto. Se tenho
              uma prova bem importante na escola, vou investir meu tempo em
              estudar, já que é minha prioridade máxima no momento. Portanto,
              um segredo é descobrir o que realmente importa pra você e quando
              deve colocar suas ideias e ações em prática. Tudo tem o melhor
              momento para acontecer e florescer.
            </p>

            <div class="btn-header mt-6 pt-2">
              <base-button type="secondary">
                <router-link to="/intro" >Fazer o Teste</router-link>
              </base-button>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import { Tooltip } from 'element-ui'
  export default {
    name: 'home-page',
    components: {
      [Tooltip.name]: Tooltip,
    }
  };
</script>
